'use client';

import { TypesenseEventDocument } from '@/types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface GlobalState {
  /** open state of the booking sheet */
  openBook: boolean;
  setOpenBook: (open: GlobalState['openBook'], path?: string) => void;

  /** open state of the navigation menu */
  openMenu: boolean;
  setOpenMenu: (open: GlobalState['openMenu']) => void;

  /** the tab selected in the booking sheet */
  bookTab: 'tonic' | 'design-my-night';
  setBookTab: (tab: GlobalState['bookTab']) => void;

  /** the event selected in the booking sheet */
  bookEvent: TypesenseEventDocument | null;
  setBookEvent: (event: GlobalState['bookEvent']) => void;

  /** the entrypoint for venue level pages */
  placePrefix: string | null;
  setPlacePrefix: (placePrefix: GlobalState['placePrefix']) => void;

  /** config for the designMyNight widget in the booking sheet */
  dmnConfig: {
    venue?: string;
    affiliateId?: string;
    allowedTypes?: string;
    date?: string;
    numberOfGuests?: string;
    searchVenues?: boolean;
    showTypeFirst?: boolean;
    hideOffers?: boolean;
    hidePoweredBy?: boolean;
    returnUrl?: string;
    customSource?: string;
    googleTagManagerCode?: string;
  };
  setDmnConfig: (config: GlobalState['dmnConfig']) => void;
}

export const useGlobal = create<GlobalState>()(
  devtools((set) => ({
    placePrefix: null,
    setPlacePrefix: (placePrefix) => set({ placePrefix }),

    openBook: false,
    setOpenBook: (open, path) =>
      set({
        openBook: open,
        // automatically open the tickets UI if the user is looking at events
        ...(path && path.includes('events') && { bookTab: 'tonic' }),
        // clear the event in the booking sheet on close
        ...(!open && { bookEvent: null }),
      }),

    openMenu: false,
    setOpenMenu: (open) => set({ openMenu: open }),

    bookTab: 'design-my-night',
    setBookTab: (tab) => set({ bookTab: tab }),

    bookEvent: null,
    setBookEvent: (event) => set({ bookEvent: event }),

    dmnConfig: {},
    setDmnConfig: (config) => set({ dmnConfig: config }),
  })),
);
